




















































































































































































































































































import {Vue, Component, Prop} from "vue-property-decorator";

import Comments from "../components/Comments.vue";
import Tooltip from "../components/Tooltip.vue";
import Mitigations from "../components/Mitigations.vue";
import {AttackType} from "@/types/riskPrioritization.type";
import {
    RiskItemType,
    RiskTableType,
    ScaleDictType
} from "@/types/riskPrioritization.type";

@Component({components: {Comments, Tooltip, Mitigations}})
export default class RiskComponent extends Vue {
    @Prop() private riskItem!: RiskTableType;

    openModal = false;

    get attackTypes(): AttackType[] {
        const types: AttackType[] = [
            {
                name: "Confidentiality",
                icon: "mdi-eye-outline",
                iconColor: "blue",
                score: this.riskItem.riskScore.confidentiality,
                tier: this.riskItem.capability.confidentiality,
                importance: this.riskItem.question.importanceQuestions.questions
                    .confidentiality.userInput.userValue
            },
            {
                name: "Integrity",
                icon: "mdi-shield-outline",
                iconColor: "green",
                score: this.riskItem.riskScore.integrity,
                tier: this.riskItem.capability.integrity,
                importance: this.riskItem.question.importanceQuestions.questions
                    .integrity.userInput.userValue
            },
            {
                name: "Availability",
                icon: "mdi-clock-outline",
                iconColor: "orange",
                score: this.riskItem.riskScore.availability,
                tier: this.riskItem.capability.availability,
                importance: this.riskItem.question.importanceQuestions.questions
                    .availability.userInput.userValue
            }
        ];
        return types;
    }
}
